import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import topLevelRoutes from 'routes/topLevelRoutes';
import { Home, PageNotFound } from 'containers';
import 'assets/css/App.css';
import 'assets/css/TipTap.css';
import 'moment-countdown';

window.onerror = () => true;

export default function() {
  const routes = topLevelRoutes.filter(route => route.path !== '/');
  return (
    <Router>
      <Switch>
        {<Route component={Home} exact path="/" />}
        {routes.map(({ component, path }) => (
          <Route component={component} key={path} path={path} />
        ))}
        <Route component={PageNotFound} />
      </Switch>
    </Router>
  );
}
